import React, { useMemo } from 'react';
import AlternateTooltip from '~/modules/common/components/TaskStatusSection/Table/components/ChildInfoDialog/AlternateTooltip';
import { isNullOrUndefined } from '~/modules/common/util';
import { useAlternateTooltipStyles } from './styles';

export const useAlternateHoursTooltips = ({
  isProjectVariant,
  hasChildTasks,
  estimatedHours,
  rolledUpSummary,
  isClosed
}) => {
  const classesOverride = useAlternateTooltipStyles();

  const {
    totalProjectTasksEstimatedAtCompletionHours,
    totalEstimatedAtCompletionHours,
    actualHours
  } = rolledUpSummary || {};

  const hasAlternateEstimatedAtCompletionHoursValue =
    !isClosed &&
    isProjectVariant &&
    !actualHours &&
    !isNullOrUndefined(totalEstimatedAtCompletionHours) &&
    isNullOrUndefined(totalProjectTasksEstimatedAtCompletionHours);

  const estimatedAtCompletionHoursRowTooltipCondition = isProjectVariant
    ? !isClosed &&
      (hasChildTasks || hasAlternateEstimatedAtCompletionHoursValue)
    : hasChildTasks;

  const isClosedProjectVariant = isProjectVariant && isClosed;

  const workRemainingHoursRowTooltipCondition =
    hasChildTasks || isClosedProjectVariant;

  const atleastOneHoursRowHasTooltip =
    estimatedAtCompletionHoursRowTooltipCondition ||
    hasChildTasks ||
    workRemainingHoursRowTooltipCondition;

  const estimatedAtCompletionAlternateHoursTooltipComponent = useMemo(
    () =>
      hasAlternateEstimatedAtCompletionHoursValue ? (
        <AlternateTooltip
          messageId={
            !isNullOrUndefined(estimatedHours)
              ? 'projectDrawer.hoursEacFromProjectEstimatesMessage'
              : 'projectDrawer.hoursEacFromProjectBudgetMessage'
          }
        />
      ) : null,
    [estimatedHours, hasAlternateEstimatedAtCompletionHoursValue]
  );

  const workRemainingAlternateHoursTooltipComponent = useMemo(
    () =>
      isClosedProjectVariant ? (
        <AlternateTooltip
          classes={classesOverride}
          messageId="projectDrawer.workRemainingForClosedProjectMessage"
        />
      ) : null,
    [classesOverride, isClosedProjectVariant]
  );

  return {
    estimatedAtCompletionHoursRowTooltipCondition,
    workRemainingHoursRowTooltipCondition,
    atleastOneHoursRowHasTooltip,
    hideVariationRowHoursTooltip: isClosedProjectVariant,
    hideEstimatedAtCompletionRowHoursTooltip: isClosedProjectVariant,
    estimatedAtCompletionAlternateHoursTooltipComponent,
    workRemainingAlternateHoursTooltipComponent
  };
};

export default useAlternateHoursTooltips;

export const hasRowMarginCondition = (atleastOneRowHasTooltip, rowHasTooltip) =>
  !rowHasTooltip && atleastOneRowHasTooltip;

export const hasVariationRowMarginCondition = ({
  variationHours,
  hasChildTasks,
  atleastOneHoursRowHasTooltip,
  hideTooltip
}) =>
  hideTooltip ||
  (variationHours === null && hasChildTasks) ||
  hasRowMarginCondition(atleastOneHoursRowHasTooltip, hasChildTasks);
